import { StaffRequestView } from 'utils/ManagementEndpointRequest/TimelineSocket'

export const getSalons = () => {
  return StaffRequestView.get(`/v1/salons`)
}
